/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/default-props-match-prop-types */
import React, { FC, AnchorHTMLAttributes, Ref } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { ThemeType } from '@shared/types';
import { textFontSizes, textFontWeights, textLineHeights, resetedLineHeight } from '@shared/config/text';
export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  colorType?: 'default' | 'dark' | 'currentColor' | 'premiumBanking';
  activeColor?: string;
  /**
   * цвет псевдокласса :active
   */
  /** should link be inline element ( i.e. it`s already wrapped in Text component)  */
  inline?: boolean;
  /** link coloring style */
  linkRef?: Ref<HTMLAnchorElement>;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  sizemob?: 'sm' | 'md' | 'lg' | 'xl';
  textDecoration?: 'underline' | 'none';
}
const Link: FC<LinkProps> = ({
  colorType,
  activeColor,
  inline,
  linkRef,
  size,
  sizemob,
  children,
  textDecoration,
  ...rest
}) => {
  let linkChildren = children;
  if (!inline) {
    if (typeof children === 'string') {
      linkChildren = <Wrapper size={size} sizemob={sizemob} color="inherit">
          {children}
        </Wrapper>;
    } else if (Array.isArray(children)) {
      linkChildren = React.Children.map(linkChildren, child => {
        if (typeof child === 'string') {
          return <Wrapper color="inherit">{child}</Wrapper>;
        }
        return child;
      });
    }
  }
  return <LinkWrapper ref={linkRef} inline={inline} colorType={colorType} data-testid="link" activeColor={activeColor} $textDecoration={textDecoration} {...rest}>
      {linkChildren}
    </LinkWrapper>;
};
interface WrapperProps {
  sizemob?: 'sm' | 'md' | 'lg' | 'xl';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  resetLineHeight?: boolean;
  align?: 'left' | 'center' | 'right' | 'inherit';
  capitalize?: boolean;
  nowrap?: boolean;
  weight?: 'regular' | 'medium' | 'bold' | 'black';
  $color?: string;
}

// @ts-ignore
const _exp = /*#__PURE__*/() => ({
  nowrap
}) => nowrap ? 'nowrap' : 'pre-line';
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSSans;
const _exp3 = /*#__PURE__*/() => ({
  sizemob,
  size
}) => textFontSizes.par[sizemob as 'sm' || size];
const _exp4 = /*#__PURE__*/() => ({
  weight
}) => textFontWeights[weight as 'regular'];
const _exp5 = /*#__PURE__*/() => ({
  sizemob,
  size,
  resetLineHeight
}) => resetLineHeight ? resetedLineHeight : `${textLineHeights.par[sizemob as 'sm' || size]}px`;
const _exp6 = /*#__PURE__*/() => ({
  align
}) => align || '';
const _exp7 = /*#__PURE__*/() => ({
  capitalize
}) => capitalize ? 'uppercase' : 'none';
const _exp8 = /*#__PURE__*/() => ({
  $color
}) => $color || '';
const _exp9 = /*#__PURE__*/() => ({
  size
}) => textFontSizes.par[size as 'sm'];
const _exp0 = /*#__PURE__*/() => ({
  size,
  resetLineHeight
}) => resetLineHeight ? resetedLineHeight : `${textLineHeights.par[size as 'sm']}px`;
const Wrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1v5sffz",
  propsAsIs: false,
  vars: {
    "w1v5sffz-0": [_exp()],
    "w1v5sffz-1": [_exp2()],
    "w1v5sffz-2": [_exp3(), "px"],
    "w1v5sffz-3": [_exp4()],
    "w1v5sffz-4": [_exp5()],
    "w1v5sffz-5": [_exp6()],
    "w1v5sffz-6": [_exp7()],
    "w1v5sffz-7": [_exp8()],
    "w1v5sffz-8": [_exp9(), "px"],
    "w1v5sffz-9": [_exp0()]
  }
}));
const getColor = (type: 'dark' | 'currentColor' | 'default' | 'premiumBanking', theme: ThemeType) => {
  if (type === 'dark') return theme.colors.text.black;
  if (type === 'currentColor') return 'currentColor';
  if (type === 'default') return theme.colors.state.primaryLinkHover;
  if (type === 'premiumBanking') return '#00525D';
};
interface LinkWrapperProps extends Pick<LinkProps, 'colorType' | 'activeColor' | 'inline'> {
  $textDecoration: LinkProps['textDecoration'];
}
const _exp1 = /*#__PURE__*/() => ({
  inline
}) => inline ? 'inline' : 'inline-flex';
const _exp10 = /*#__PURE__*/() => ({
  colorType,
  theme
}) => getColor(colorType as 'default', theme) as string;
const _exp11 = /*#__PURE__*/() => ({
  $textDecoration
}) => $textDecoration === 'underline' && 'underline' || '';
const _exp12 = /*#__PURE__*/() => ({
  colorType,
  activeColor,
  theme
}: LinkWrapperProps & ThemeProps) => {
  if (activeColor) {
    return activeColor;
  }
  return colorType === 'dark' || colorType === 'currentColor' ? theme.colors.text.grey300 : theme.colors.text.black;
};
const LinkWrapper = withTheme(/*#__PURE__*/styled('a')({
  name: "LinkWrapper",
  class: "l1k7jzh5",
  propsAsIs: false,
  vars: {
    "l1k7jzh5-0": [_exp1()],
    "l1k7jzh5-1": [_exp10()],
    "l1k7jzh5-2": [_exp11()],
    "l1k7jzh5-3": [_exp12()]
  }
}));
Link.defaultProps = {
  colorType: 'default',
  inline: true,
  textDecoration: 'none'
};
export default Link;

require("./Link.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Link.tsx");